// Deep-link to a runner.
//   ?pick=<slug>     expands the card (closing the others in its race) and
//                    briefly highlights it; the page stays at the top.
//   #runner-<slug>   legacy links: expand + highlight + scroll into view.
import { setExpanded } from './runner_toggle.js';

const HASH_RE = /^#runner-[a-z0-9-]+$/;
const SLUG_RE = /^[a-z0-9-]+$/;

// Accordion: one open card per .race-runners block.
export function closeOtherCards(card) {
  const scope = card.closest('.race-runners');
  if (!scope) return;
  scope.querySelectorAll('.runner-card.expanded').forEach((c) => {
    if (c !== card) setExpanded(c, false);
  });
}

// Tap on a card: open it (closing the others in its race) or close it.
// `.expanded` is the only open state, shared with ?pick= and server markup.
export function toggleCard(card) {
  const open = !card.classList.contains('expanded');
  if (open) closeOtherCards(card);
  setExpanded(card, open);
}

export function initRunnerAnchor({
  root = document,
  hash = window.location.hash,
  matchMedia = window.matchMedia,
  setTimeout: st = window.setTimeout,
  search = window.location.search,
} = {}) {
  let id = null;
  let scroll = false;
  if (hash) {
    if (HASH_RE.test(hash)) {
      id = hash.slice(1);
      scroll = true;
    }
  } else {
    const pick = new URLSearchParams(search || '').get('pick');
    if (pick && SLUG_RE.test(pick)) id = 'runner-' + pick;
  }
  if (!id) return null;

  const card = root.getElementById(id);
  if (!card) return null;

  const overflow = card.closest('.rc-overflow');
  if (overflow) {
    overflow.classList.add('open');
    const btn = root.getElementById('rcShowMore');
    if (btn) btn.innerHTML = 'Show top 5 only &#x2191;';
  }
  closeOtherCards(card);
  setExpanded(card, true);

  const reduced = !!(matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (scroll && typeof card.scrollIntoView === 'function') {
    card.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
  }

  card.classList.add('rc-target');
  if (reduced) {
    st(() => card.classList.remove('rc-target'), 3000);
  } else {
    st(() => card.classList.add('rc-target-fade'), 3000);
    st(() => card.classList.remove('rc-target', 'rc-target-fade'), 4500);
  }
  return card;
}
